import { Observable } from "rxjs"
import { ObservableFromFetchWithTaskData } from "../ObservableFromFetch"
import RunRandomSelectionMessage from "./RandomsModel/RunRandomSelectionMessage"

export default function RunRandomSelectionMessagesGetObservable(poolId: number): Observable<RunRandomSelectionMessage> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString()
  }).toString()

  return ObservableFromFetchWithTaskData<RunRandomSelectionMessage>("RandomTest/RandomSelectionMessage?" + requestBody)
}
